/**
 * Player Progress Bar snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_PlayerProgressBar
 * @extends Snippet
 */

Snippet_PlayerProgressBar = (function(Snippet) {

	var Snippet_PlayerProgressBar = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_PlayerProgressBar.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			console.log("[Snippet_PlayerProgressBar] init");
			var scope = this;
			
			this.model = config.model || null;
			
			this.isVisibleScrubber = false;
			this.timeScrubber = 0;  // scrubber time [ms]
			this.time = 0;          // current playing time [ms]
			this.duration = 0;      // video duration [ms]
			this._seekingTimer = null;
			
			this.$scrubber = this.$el.find(".scrubber");
			this.$scrubberTime = this.$el.find(".scrubber-time");
			this.$timeBar = this.$el.find(".time-bar");
			this.$progressBar = this.$el.find(".progress-bar");
			
			this.$scrubber.on("transitionend webkitTransitionEnd", function(event) {
				scope.onEndAnimation(event);
			});
		},
		
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-player-progress-bar");
			}
		},
		
		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			this.clear();
		},
		
		/**
		 * To update progress bar
		 * @param {Number} time [ms]
		 * @param {Number} duration [ms]
		 */
		update: function(time, duration) {
			this.time = time = time || 0;  // in ms
			this.duration = duration = duration || 0; // in ms
			
			var percent = duration ? time/duration * 100 : 0;

			this.setProgress(time, duration, percent);
		},
		
		/**
		 * Set progress time bar
		 * @param {Number} time in ms
		 * @param {Number} duration in ms
		 * @param {Number} percent in %
		 */
		setProgress: function(time, duration, percent) {
			this.$timeBar.width(percent + '%');

			if(!this.isVisibleScrubber && !this.$scrubber.hasClass("animate")) {
				this.setScrubber(time, duration, percent);
			}
		},
		
		/**
		 * To set Scrubber (position, time text)
		 */
		setScrubber: function(time, duration, percent) {
			percent = percent || (duration ? time/duration * 100 : 0);

			var timeStr = this.formatTime(time / 1000);
			
			var wrapWidth = this.$progressBar.width();
			var scrubberLeftOffset = parseInt(this.$scrubber.innerWidth(), 10) / 2;
			var left = (wrapWidth/100 * percent) - scrubberLeftOffset;
			left = left < -scrubberLeftOffset ? -scrubberLeftOffset : left > (wrapWidth-scrubberLeftOffset) ? (wrapWidth-scrubberLeftOffset) : left;
			
			this.timeScrubber = time;
			this.$scrubberTime.html(timeStr);
			this.$scrubber.css("left", left);
		},
		
		formatTime: function(seconds) {
			if(!seconds) {
				return '00:00';
			}
			var hours = Math.floor(seconds / 3600);
			var minutes = Math.floor((seconds - (hours * 3600)) / 60);
			seconds = Math.floor(seconds - (hours * 3600) - (minutes * 60));
			if (hours <= 0) return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
			return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
		},
		
		/**
		 * To show Scrubber
		 */
		showScrubber: function() {
			this.$scrubber.addClass("focusable");
			if(this.isVisibleScrubber) {
				return false;
			}
			
			this.isVisibleScrubber = true;
			this.$scrubber.removeClass("animate").css({opacity: 0, marginTop: "20px"});  // stop-reset
			this.$scrubber.show().addClass("animate");
			this.$scrubber[0].offsetHeight; // force to redraw/repaint the Webkit
			this.$scrubber.css({opacity: 1, marginTop: "0px"});
		},
		
		/**
		 * To hide Scrubber
		 */
		hideScrubber: function(forceHide) {
			if(!this.isVisibleScrubber && !forceHide) {
				return false;
			}

			this.isVisibleScrubber = false;
			
			this.$scrubber.addClass("animate").css({opacity: 0, marginTop: "20px"});
			this.$scrubber.removeClass("focusable");
			if(forceHide) {
				this.onEndAnimation();
			}
		},
		
		/**
		 * To show fast seeking (automatic Scrubber moving)
		 */
		fastSeeking: function(speed){
			var scope = this;
			this.stopFastSeeking();
			if(!this.isVisibleScrubber){
				this.showScrubber(false);
			}

			this._seekingTimer = window.setInterval(function() {
				var direction = speed >= 1 ? 1 : -1;
				var wrapWidth = scope.$progressBar.width();
				var step = wrapWidth / (scope.duration*0.001);
				step = Math.abs(speed) * step;
				scope.moveScrubber(direction, step);
			}, 1000);
		},
		
		/**
		 * To hide fast seeking (stop seeking + hide Scrubber)
		 */
		hideFastSeeking: function(){
			this.stopFastSeeking();
			this.hideScrubber(true);
		},
		
		/**
		 * To stop fast seeking
		 */
		stopFastSeeking: function(){
			if(this._seekingTimer){
				window.clearTimeout(this._seekingTimer);
			}
		},
		
		/**
		 * Callback function, called on EndAnimation
		 */
		onEndAnimation: function(event) {
			if(!this.isVisibleScrubber) {
				this.$scrubber.removeClass("animate");
				this.$scrubber.hide();
				this.$scrubber.removeClass("active");
			}
		},
		
		/**
		 * To move Scrubber
		 * @param {Number} dir - set 1 for move to right, set -1 for move to left
		 * @param {Number} step - step of move
		 */
		moveScrubber: function(dir, step) {
			var wrapWidth = this.$progressBar.width();
			var scrubberLeftOffset = parseInt(this.$scrubber.innerWidth(), 10) / 2;
			var minPos = -scrubberLeftOffset;
			var maxPos = wrapWidth - scrubberLeftOffset;
			var pos;
			step = step || (this.duration <= 600 ? 25 : 10);  // in px
			var time = this.timeScrubber || 0;
			
			if (!this.isVisibleScrubber) {
				return;
			}
			
			pos = parseInt(this.$scrubber.css('left'), 10) + (dir * step);
			
			if(pos < minPos) {
				pos = minPos;
				time = 0;
			} else if(pos > maxPos) {
				pos = maxPos;
				time = this.duration;
			} else {
				time = time + (dir * (Math.round((this.duration / wrapWidth) * step * 100) / 100));
			}
			
			var timeStr = this.formatTime(time / 1000);
			
			this.show();
			this.$scrubber.css('left', pos);
			this.$scrubberTime.html(timeStr);
			this.timeScrubber = time;
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var control = $el.attr('data-id');

			switch(control) {
				case 'seek':
					this.setPlayingPosition(this.timeScrubber);						
					break;
				case 'mouseSeek':
					this.seekByMouse($el, event);
					break;
				default: break;
			}
			return false;
		},
		
		/**
		 * Seek by mouse
		 */
		seekByMouse: function($el, e) {
			if(this.parent.playerControlsSnip.currentSpeed !== 1) {
				return;
			}
			
			var w = $el.width(),
				o = $el.offset(),
				x = e.clientX || 0;

			if (o.left < x && (x < o.left + w)) {
				p = 100 / w * (x - o.left);
	
				if (p && p <= 100) {
					this.setPlayingPosition(Math.round(this.duration / 100 * p));
				}
	
				return false;
			}
		},
		
		/**
		 * @param {Number} time position [ms]
		 */
		setPlayingPosition: function(time) {
			if(Player.speed !== 1){
				Player.playbackSpeed(1);
			}
			App.throbber(false);
			var PlayerScene = this.parent.parent;
			if(time > Player.duration - 5000) {
				time = Player.duration - 5000;
			}
			PlayerScene.seek(time, true);  // scene.seek
			this.navigate('down');
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function( direction ) {
			switch ( direction ) {

				case 'up':
					this.trigger( 'focus:out', this, direction ); //showPlayerUI
					break;

				case 'down':
					this.hideScrubber();
					this.parent.focus();
					break;

				case 'left':
					this.moveScrubber( -1, null );
					break;

				case 'right':
					this.moveScrubber( 1, null );
					break;

				default:
					break;
			}
			return false;
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if ($el && $el.length) {
				return Focus.to($el);
			} else if(this.parent.playerControlsSnip.currentSpeed !== -1) {
				this.parent.playerControlsSnip.hideSpeed();
				this.stopFastSeeking();
				this.showScrubber();
				return Focus.to(this.$scrubber);
			} else {
				this.showScrubber();
				return Focus.to(this.$scrubber);
			}
		},
		
		clear: function( keepWidth ) {
			window.clearTimeout(this._seekingTimer);
			this.$timeBar.width('0');
			this.$scrubber.removeClass("animate").css({opacity: 0, marginTop: "20px", left: 0});
			this.$scrubberTime.html('00:00');
			this.$scrubber.hide();
			this.isVisibleScrubber = false;
			this.timeScrubber = 0;  // scrubber time [ms]
			this.time = 0;          // current playing time [ms]
			this.duration = 0;      // video duration [ms]
		},
		
		isFocusable: function() {
			return true;
		}
	});

	return Snippet_PlayerProgressBar;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/player_progress_bar.js
// module id = 72
// module chunks = 0